var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>A step may be optional or required. If a step is optional it typically means the step only needs to be applied under certain conditions, to improve results beyond functionally, or to yield useful but not-critical outputs. The conditions of this can be specified in the text box provided.</p>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_docs/snippets/required.hbs
// module id = 152
// module chunks = 0